import { useSuspenseQuery } from '@connectrpc/connect-query'
import { useTranslation } from 'react-i18next'

import { getApiKey } from '~/gen/proto/bff/v1/admin-BffAdminService_connectquery'
import { ApiKey } from '~/gen/proto/bff/v1/model_pb'

export function useApiKey(id: string): ApiKey {
  const { t } = useTranslation()
  const res = useSuspenseQuery(
    getApiKey,
    { id },
    {
      select: (data) => data.apiKey,
    },
  )
  if (res.isError || res.data === undefined) {
    throw new Error(t('message.fetchFail', { entity: t('domain.apikey') }))
  }
  return res.data
}
